import {Model} from '@vuex-orm/core';
import {IAttitude} from '@/interfaces/planner/purpose/IAttitude';

// @ts-ignore
export default class Attitude extends Model implements IAttitude {
    public static entity = 'master_attitudes';

    public static fields() {
        return {
            id: this.number(0),
            text: this.string(''),
            codigo: this.string(''),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),
        };
    }
}
